<div class="page-wrapper" [ngClass]="{ haptic: this.config.modalities[0].active }">
  <div class="publication-list"  [ngClass]="{ darkMode: this.config.theme === 'dark-mode'}">


    <div class="section-header" [ngClass]="{ haptic: this.config.modalities[0].active }">
      <div class="section-title">Publications</div>


        <p class="body_title"><br><br>
 <a href="https://pure.au.dk/portal/en/persons/eve.hoggan%40cs.au.dk" target="_blank" rel="noopener noreferrer">
  Eve Hoggan's PURE Profile at Aarhus University
</a><br><br>
        <a href="https://scholar.google.dk/citations?user=EIU2kHUAAAAJ&hl=en&oi=ao" target="_blank" rel="noopener noreferrer">
    Eve Hoggan's Google Scholar Profile
  </a>
  <br><br><br><br>

</div>
<br><br><br><br>

    </div>






  <app-footer></app-footer>
</div>
